import PractitionerInfo from './PractitionerInfo';

export default PractitionerInfo;
